import React, { CSSProperties } from 'react';

type GlowCircleProps = {
  size?: number;
  width?: number;
  height?: number;
  color: string;
  stopOffset?: string;
  stopOpacity?: number;
  opacity?: number;
  blur?: number;
  style?: CSSProperties;
};

export const GlowCircle: React.FC<GlowCircleProps> = ({
  size,
  width = size,
  height = size,
  color,
  stopOffset = '20%',
  stopOpacity = 0.3,
  opacity = stopOpacity,
  style,
}) => {
  const gradientId = `glow-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div
      style={{
        width,
        height,
        ...style,
      }}>
      <svg width={width} height={height} style={{ display: 'block' }}>
        <defs>
          <radialGradient id={gradientId} cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
            <stop offset={stopOffset} stopColor={color} stopOpacity={opacity} />
            <stop offset="100%" stopColor={color} stopOpacity={0} />
          </radialGradient>
        </defs>
        <rect width={width} height={height} fill={`url(#${gradientId})`} />
      </svg>
    </div>
  );
};
